import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import SlideControls from './slide-controls'
import spectator from 'scoreboard/components/spectator'
import appDisplay from 'scoreboard/components/app-display'
import BriefingsOverview from './briefings-overview'
import conductor from 'scoreboard/components/conductor'
import globals from 'scoreboard/components/globals'
import calendars from 'scoreboard/components/calendars'
import constants from 'scoreboard/components/constants'
import briefingsLayoutManager from './briefings-layout-manager'
import projects from 'scoreboard/projects/projects'

var currentSlide

var debug = false

function Briefer() {
	// on every route toggle the slide pane.  This is important to hide the
	// slide-pane in sections outside briefings.  TODO: this causes a visible
	// flicker.  for example, visit a BB, then click to the scorecards section.
	// The slide pane instantly hides, but the display pane remains unchanged
	// until the request needed to render the display pane finishes.  this
	// makes the briefing book inside the display pane jerk up to the top of
	// the window before it is replaced with a display from the scorecards
	// section
	Backbone.history.on('before:route', this._adjustPeriodId.bind(this))
}

_.extend(Briefer.prototype, Backbone.Events, {

	// keeps track of the most recently loaded Briefing model in case we press
	// stop and need the list of slides to display in the slide-pane
	lastLoadedBriefing: null,

	// while navigating around briefings sometimes we need to view one period
	// in the application, but when we're done we want to return where we were
	// before.  this periodId keeps track of where we used to be, and
	// globals.periodId keeps track of what period is currently being displayed
	periodId: null,

	// When initially rendering a fixed period slide, we set the global calendar
	// period to the fixed period.  To allow the global period calendar to change
	// if the view is re-rendered from a period change, we need to distinguish
	// between the initial view of a slide and subsequent views.  This variable
	// will track the last viewed slide so we can compare and determine if we're
	// still viewing the same slide when re-rendering
	lastViewedSlideId: null,

	// show the briefing controls if appropriate.  available modes (which will
	// be added as a class to the DOM element for the slide controls):
	//    constants.BRIEFING_MODE_IS_EDITING_BRIEFING
	//    constants.BRIEFING_MODE_IS_EDITING_SLIDE
	//    constants.BRIEFING_MODE_IS_VIEWING_SLIDE
	show: function(briefing, slideId, mode) {
		this.navDisplayPane = $('.nav-display-pane')

		var slide = briefing.slides().get(slideId)
		currentSlide = slide
		slide && spectator.setCurrent(slide)
		this.forceShow()

		// adjust the period (needed when initially loading the application to
		// a specific slide)
		if (slide) {
			// #23600 if visiting the briefing for the first time
			if (!this.periodId) {
				// remember the periodId we started with
				this.periodId = globals.periodId
				if (debug) {
					console.log('this.periodId -> ' + _.result(calendars.periodsById[this.periodId], 'label'))
				}
			}
			this.adjustGlobalsPeriodId(slide)
		}

		// make sure the slide controls are displayed properly
		this.slideControls = appDisplay.slideView()
		let isPaused = briefingsLayoutManager.isPaused()
		// if not showing slide controls for the correct briefing
		if (!this.slideControls
			|| !document.body.contains(this.slideControls.el)
			|| (this.slideControls.model.id != briefing.id && !isPaused)) {
			this._setupSlideControls(briefing, slideId)
		} else if (!isPaused) {
			// important: make sure the slide controls has the correct model
			// so it can listen for changes to slides
			this.slideControls.setModel(briefing)
			// also make sure the correct slide is displayed (needed
			// after clicking the back button)
			this.slideControls.setSlideId(slideId)
		}

		this.slideControls.setMode(mode)
		this.lastViewedSlideId = slideId

		return this.slideControls
	},

	// callback when the slide is changed by the user using the slideControls
	viewSlide: function(slideId) {
		// _adjustPeriodId is required if the first screen viewed is a slide
		this._adjustPeriodId()
		var briefing = this.slideControls.model
		if (slideId) {
			var slide = briefing.slides().get(slideId)
			this.adjustGlobalsPeriodId(slide)
			// important if initially loading the entire application
			// with a specific slide in the URL
			this.slideControls.setSlideId(slideId)
		}
		// do this AFTER adjustGlobalsPeriodId
		if (this.slideControls.getMode() === constants.BRIEFING_MODE_IS_EDITING_SLIDE) {
			conductor.navigate('briefings/' + briefing.id + '/slides/' + slideId + '/edit', { trigger: true })
		} else {
			// create a new entry in the history.  must go before the call to
			// the BriefingsOverview
			conductor.navigate('briefings/' + briefing.id + '/slides/' + slideId)
			this.show(briefing, slideId, this.slideControls.getMode())
			new BriefingsOverview({ model: briefing, slideId: slideId }).render()
		}
	},

	_setupSlideControls: function(briefing, slideId) {
		_.invoke(this.slideControls, 'remove')
		this.slideControls = new SlideControls({ model: briefing, slideId: slideId })
		appDisplay.slide(this.slideControls)

		// all these event handlers are to keep SlideControls encapsulated,
		// since this code interacts with stuff outside the SlideControls

		this.slideControls.on('view', this.viewSlide.bind(this))

		this.slideControls.on('resume', function(slideId) {
			var slide = briefing.slides().get(slideId)
			// when resuming, go back to the the period where we left off
			this.adjustGlobalsPeriodId(slide)
			// need to do this to (1) fix the URL, (2) ensure briefings are
			// highlighted in the head pane, and (3) ensure the briefing tree is
			// shown in the nav pane
			var url = 'briefings/' + briefing.id + '/slides/' + slideId
			conductor.navigate(url, { trigger: true })
			// Reset the project and organization so the nav menu reflects
			// the correect info there #31990
			projects.id = briefing.get('projectId')
			globals.orgId = briefing.get('organizationId')
			this.slideControls.togglePaused(false)
		}.bind(this))
	},

	// Syncs the period displays in the display-header and slide controls
	syncPeriodDisplays(displayHeaderPeriodDisplay) {
		displayHeaderPeriodDisplay.on('change:period', (id) => {
			// Prevent the slide-control's period-display from refreshing itself since
			// the period-display in the display-header has to trigger the change:period
			// event for the display pane content to update.
			if (this.periodDisplayId !== id && this.slideControls) {
				// Slide controls only need to refresh because the display-pane content isn't listening to it.
				this.slideControls.periodDisplay.refresh(id)
			}
		})
		this.slideControls && this.slideControls.periodDisplay.on('change:period', (id) => {
			this.periodDisplayId = id
			// changePeriod() method is needed to trigger the events for which the the dislay-pane is listening.
			displayHeaderPeriodDisplay.changePeriod(id)
		})
	},

	getSlideId: function() {
		return _.result(this.slideControls, 'getSlideId')
	},

	getBriefingId: function() {
		return _.result(this.slideControls, 'model.id')
	},

	// force the briefing controls to display
	forceShow: function() {
		this.toggleBriefingLayout(true)
	},

	// When switching slides, the display-header either renders a new period-display or it has no period-display.
	// If there is a period-display, this adds a matching period-display with synced behavior to the slide-controls.
	// Otherwise, pass in `false` and this will remove the old period-display from the slide-controls.
	slideControlsPeriodDisplay(periodDisplay, periodId, relative, periodDelta) {
		this.slideControls && this.slideControls.updatePeriodDisplay(periodDisplay, periodId, relative, periodDelta)
	},

	// toggles the briefing layout based on the value of showBriefingLayout
	toggleBriefingLayout: function(showBriefingLayout) {
		briefingsLayoutManager.toggleBriefingLayout(showBriefingLayout)

		if (!showBriefingLayout && 'bookmarks' != _.get(spectator.getCurrent(), 'section')) {
			spectator.setCurrent(null)

			if (Backbone.history.fragment.indexOf('briefings') == -1) {
				// By now, we're leaving the briefings section and we're not spectating an item while
				// in presentation mode. Since we're leaving briefings totally,
				// we have no need for the .slide-controls to stay around,
				// so nix them lest they cause trouble (#19354)
				_.invoke(this.slideControls, 'remove')
			}
		}
	},

	// toggle the briefing layout based on the state of the application
	_toggleBriefingLayout: function() {
		var paused = _.result(appDisplay.slideView(), 'paused')
		var fullscreen = _.result(appDisplay.slideView(), 'fullscreen')
		var briefing = conductor.section() === 'briefings' &&
			Backbone.history.fragment.indexOf('new-folder') == -1
		var showBriefingLayout = fullscreen || paused || briefing
		this.toggleBriefingLayout(showBriefingLayout)
		this.navDisplayPane.removeClass('item-not-found')

		if (fullscreen) {
			appDisplay.slideView().togglePaused(paused)
		}
	},

	isShowingBriefing: function() {
		// spectator.getCurrent() examines the current URL so it can
		// figure out whether we're in a briefing still even though the route
		// hasn't executed yet
		return !!(spectator.getCurrent() &&
			spectator.getCurrent().section === 'briefings')
	},

	_adjustPeriodId: function() {
		if (this.isShowingBriefing() || _.result(appDisplay.slideView(), 'fullscreen')) {
			// if visiting the briefing for the first time
			if (!this.periodId) {
				// remember the periodId we started with
				this.periodId = globals.periodId
			}
		// if we left the briefing entirely
		} else {
			// #23235 restore the non-relative period since we're leaving briefings
			globals.periodId = this.periodId || globals.periodId
			// clear out the periodId (it's not needed outside briefings and when
			// first visiting a slide we need it to be null so we know to lock in a
			// new periodId)
			this.periodId = null
			// #23600 also clear out the last viewed slide
			this.lastViewedSlideId = null
		}
		if (debug) {
			console.log('this.periodId -> ' + _.result(calendars.periodsById[this.periodId], 'label'))
		}
	},

	adjustGlobalsPeriodId: function(slide) {
		slide = slide || spectator.getCurrent()

		// this.periodId is what we base relative slides on

		// if the slide has a fixed period
		if (slide.get('periodId')) {
			if (this.lastViewedSlideId != slide.id) {
				// initial viewing the slide will use the fixed period saved
				// with the slide, subsequent renders on the same slide will
				// use whatever the global period may have been set to
				globals.periodId = slide.get('periodId')
			}
		// if the slide is relative
		} else {
			// needed if you were previously editing a briefing
			this.periodId = this.periodId || globals.periodId
			// figure out the relative period
			var relativePeriod = calendars.safeRelativePeriod(this.periodId, slide.get('periodDelta') || 0)
			if (relativePeriod) {
				// ... and display that, if possible.  note if calendars need to
				// be extended it's possible that relativePeriod will be null
				globals.periodId = relativePeriod.id
			}
		}
		if (debug) {
			console.log('globals.periodId -> ' + _.result(calendars.periodsById[globals.periodId], 'label'))
		}
	},

	setCurrentView: function (view) {
		this.slideControls && this.slideControls.setCurrentView(view)
	}
})

var briefer = new Briefer()

// if you're on a relative slide and the browser is refreshed, you don't want
// to keep stepping back over and over.  this prevents that
$(window).on('unload', function() {
	globals.periodId = briefer.periodId || globals.periodId
})

export default briefer

briefer.__filename__ = 'briefings/briefer.js'
